import React from 'react';

import { Icon } from '../icons';

export const MinusIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} strokeWidth="5" viewBox="0 0 32 32" fill="none" color={color} style={style}>
      <path d="M4 17H29" stroke={color} strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
  );
};
